"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assignObjectPaths = assignObjectPaths;
exports.getLeavesFromSelectedNodes = getLeavesFromSelectedNodes;
exports.mapSelectedToTextFieldValueField = mapSelectedToTextFieldValueField;
exports.recursiveGetTreeBottom = recursiveGetTreeBottom;
exports.sanitizeOptions = sanitizeOptions;

var _get = _interopRequireDefault(require("lodash/get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/* eslint-disable complexity */
function assignObjectPaths(obj, stack) {
  var isArray = Array.isArray(obj);
  Object.keys(obj).forEach(function (k) {
    var node = obj[k];
    var key = isArray ? "[".concat(k, "]") : k;

    if (_typeof(node) === 'object') {
      node.path = stack ? "".concat(stack, ".").concat(key) : key;
      assignObjectPaths(node, node.path);
    }
  });
}
/* eslint-disable complexity */


function recursiveGetTreeBottom(node, result) {
  var _node$children;

  if (!((_node$children = node.children) !== null && _node$children !== void 0 && _node$children.length)) {
    result.push(node);
    return;
  }

  node.children.forEach(function (child) {
    return recursiveGetTreeBottom(child, result);
  });
}

function mapSelectedToTextFieldValueField(selectedOptions, textField, valueField) {
  return selectedOptions.map(function (option) {
    var _ref;

    return _ref = {}, _defineProperty(_ref, textField, option.label), _defineProperty(_ref, valueField, option.value), _ref;
  });
}
/* Must call assignObjectPaths on line 43 in TreeSelect.js if using this function */


function getLeavesFromSelectedNodes(selectedNodes, optionsList) {
  var selectedTreeBottom = [];
  selectedNodes.forEach(function (selectedNode) {
    var nodeOption = (0, _get["default"])(optionsList, selectedNode.path);
    recursiveGetTreeBottom(nodeOption, selectedTreeBottom);
  });
  return selectedTreeBottom;
} // eslint-disable-next-line max-params


function sanitizeOptions(options, textField, valueField, selectedValues) {
  var expandedNodes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var isParentChecked = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  if (!(options !== null && options !== void 0 && options.length)) {
    return [];
  }

  return options.map(function (option) {
    var checked = isParentChecked || selectedValues.some(function (selectedValue) {
      return selectedValue[valueField] === option[valueField];
    });
    var expanded = expandedNodes.some(function (node) {
      return node.value === option[valueField];
    });
    return {
      label: option[textField],
      value: option[valueField],
      checked: checked,
      expanded: expanded,
      children: sanitizeOptions(option.children, textField, valueField, selectedValues, expandedNodes, checked)
    };
  });
}